export var DEPLOY_DATE = new Date('2026-10-15T16:40:38+0000');
